import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import DashboardContext from 'Context';
import toaster from 'helper/toaster';
import { Button, Checkbox, Col, Modal, Row, Space, Table, Tag } from 'antd';
import ServicePointGroups from '../orderActions/ServicePointGroups';
import CustomPagination from 'components/table/pagination';

/**
 * این کامپوننت برای نمایش مدال پیگیری در جدول سفارشات است
 */
const WorkerServicePoints = ({ openModal, close, id, isWorker = false }) => {
  const { urldashboard, authentication, handelerrors } =
    useContext(DashboardContext);

  const [rowId, setRowId] = useState('');
  const [submitLoading, setSubmitLoading] = useState(false);
  const [workersLoading, setWorkersLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedWorkers, setSelectedWorkers] = useState([]);
  const [workerModal, setWorkerModal] = useState(false);
  const [groupModal, setGroupModal] = useState(false);
  const [data, setData] = useState([]);
  const [workers, setWorkers] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });

  useEffect(() => {
    getList({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePagination = (newPage, newPageSize) => {
    getList({
      page: newPage,
      pageSize: newPageSize,
    });
  };

  const getList = async ({ page, pageSize }) => {
    setLoading(true);
    try {
      let url = isWorker
        ? `/worker/getServicePoints`
        : `/servicePoint/getWorkers/${id}`;
      const res = await Axios.get(urldashboard + url, {
        headers: {
          Authorization: authentication,
          'Content-Type': 'application/json',
        },
        params: isWorker ? { page, pageSize, id } : null,
      });
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setData([]);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نقطه سرویس',
      dataIndex: 'servicePointTitle',
      key: 'servicePointTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'مسیر',
      dataIndex: 'transportationLineType',
      key: 'transportationLineType',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ? 'برگشت' : 'رفت'}</span>,
    },
    {
      title: 'نیروها',
      dataIndex: 'workerOrderScheduleAddressServicePoints',
      key: 'workerOrderScheduleAddressServicePoints',
      responsive: ['xl', 'lg'],
      render: (values) => (
        <Space>
          {values?.map((item) => (
            <Tag color='#7c7c7c'>{item?.workerName}</Tag>
          ))}
        </Space>
      ),
    },
    {
      title: 'تخصیص نیروها',
      dataIndex: 'orderScheduleAddressServicePointId',
      key: 'orderScheduleAddressServicePointId',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value, record) => (
        <Button
          type={'primary'}
          onClick={() =>
            handleEdit(value, record?.workerOrderScheduleAddressServicePoints)
          }
        >
          <i className='mdi mdi-account'></i>
        </Button>
      ),
    },
  ];

  const workcolumns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نقطه سرویس',
      dataIndex: 'servicePointTitle',
      key: 'servicePointTitle',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'استان',
      dataIndex: 'stateName',
      key: 'stateName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شهر',
      dataIndex: 'cityName',
      key: 'cityName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'آدرس',
      dataIndex: 'address',
      key: 'address',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'فاصله (کیلومتر)',
      dataIndex: 'distance',
      key: 'distance',
      responsive: ['xl', 'lg', 'md'],
    },
    {
      title: 'فاصله زمانی حدودی',
      dataIndex: 'duration',
      key: 'duration',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => {
        let str = value?.toString();
        let numarray = str.split('.');
        let a = new Array();
        a = numarray;
        return (
          <div>
            {a[0] > 0 && <span>{a[0]} ساعت و</span>}
            <span> {a[1]?.substring(0, 2)} دقیقه</span>
          </div>
        );
      },
    },
  ];

  const handleEdit = async (rowId, workers) => {
    setSelectedWorkers(workers?.map((item) => item?.workerOrderScheduleId));
    setWorkerModal(true);
    setWorkersLoading(true);
    setRowId(rowId);
    try {
      const res = await Axios.post(
        `${urldashboard}/workerOrderSchedule/get`,
        JSON.stringify({ page: 1, pageSize: 50, orderScheduleId: id }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.data?.map((obj) => ({ ...obj, key: obj.id }));
      setWorkers(items);
      setWorkersLoading(false);
    } catch (error) {
      handelerrors(error);
      setWorkersLoading(false);
    }
  };

  const workerColumns = [
    {
      title: 'انتخاب',
      dataIndex: 'id',
      key: 'id',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => (
        <Checkbox
          checked={selectedWorkers?.includes(value)}
          // disabled={selectedWorkers?.includes(value)}
          onChange={() => handleSubmit(value)}
        />
      ),
    },
    {
      title: 'نام نیرو',
      dataIndex: 'workerFullName',
      key: 'workerFullName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره موبایل',
      dataIndex: 'workerPhoneNo',
      key: 'workerPhoneNo',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
  ];

  const handleSubmit = async (id) => {
    setSubmitLoading(true);
    try {
      const res = await Axios.post(
        `${urldashboard}/servicePoint/setWorkers`,
        JSON.stringify({
          orderScheduleAddressServicePointId: rowId,
          workerOrderScheduleId: id,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      setSubmitLoading(false);
      const data = res?.data;
      toaster.success(data.message);
      setWorkerModal(false);
      getList({
        page: pagination?.page,
        pageSize: pagination?.pageSize,
      });
    } catch (error) {
      handelerrors(error);
      setSubmitLoading(false);
    }
  };

  return (
    <Modal
      title={`نقطه سرویسهای ثبت شده برای ${isWorker ? 'نیرو' : 'سفارش'}`}
      open={openModal}
      onCancel={close}
      closable={false}
      width={1500}
      footer={[
        <Button key='back' onClick={close}>
          بستن
        </Button>,
      ]}
    >
      <Row>
        <Col span={24}>
          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={() => 'center'}
            bordered={true}
            pagination={false}
            loading={loading}
            columns={isWorker ? workcolumns : columns}
            dataSource={data}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />

          {!loading && isWorker && (
            <CustomPagination
              totalRecord={totalRecord}
              pagination={pagination}
              handlePagination={handlePagination}
            />
          )}
        </Col>
      </Row>

      {workerModal && (
        <Modal
          title={`لیست نیروهای سفارش`}
          open={workerModal}
          onCancel={() => {
            setWorkerModal(false);
            setWorkers([]);
          }}
          closable={false}
          width={1000}
          footer={[
            <Button key='back' onClick={close}>
              بستن
            </Button>,
          ]}
        >
          <Table
            size='small'
            style={{ textAlign: 'right', marginTop: 10 }}
            rowClassName={(record) => 'center'}
            columns={workerColumns}
            bordered={true}
            dataSource={workers}
            loading={workersLoading || submitLoading}
            pagination={false}
            locale={{
              emptyText: 'موردی یافت نشد',
            }}
          />
        </Modal>
      )}

      {groupModal && (
        <ServicePointGroups
          openModal={groupModal}
          id={rowId}
          orderScheduleId={id}
          close={() => setGroupModal(false)}
        />
      )}
    </Modal>
  );
};

export default WorkerServicePoints;
